/**
 * =============================================================================
 * collection.js
 * =============================================================================
 * Collection page functionality
 * =============================================================================
 */

var Collection = {
  container: undefined,
  sectionId: undefined, // ID of the results page section, so we know what section to request via fetch
  grid: undefined,
  endless_mode: undefined, // Data injected by collection-grid.liquid

  /**
   * Initialisation
   */
  init: function() {
    this.container = document.getElementById("products-container");
    if(!this.container){
      return;
    }
    this.grid = document.getElementById("products-grid");
    this.sectionId = this.container.dataset.sectionId;

    this.setupEventListeners();
  },

  /**
   * Setup event listeners
   */
  setupEventListeners: function() {
    // Listen for 'load more' clicks, trigger the load. We need to listen on the
    // container, rather than directly on the button, as the button is
    // re-rendered / dynamically injected each time a filter is applied.
    this.container.addEventListener('click', function(event) {
      if(event.target.closest("a")?.classList.contains("load-more")){
        event.preventDefault();
        let mockedEvent = { currentTarget: event.target.closest("a"), preventDefault: () => {} };
        this.onLoadMoreClick(mockedEvent); // event has the wrong currentTarget - needs the 'a' element, but we're delegating
      };
    }.bind(this));

    // Setup a waypoint for when reaching the end of the products grid, when
    // pagination is endless (on scroll)
    if(this.endless_mode === "scroll"){
      const waypoint = new Waypoint({
        element: document.getElementById('products-container'),
        handler: function(direction) {
          if(direction === "down"){
            const loadMoreButton = this.container.querySelector(".load-more");
            if(loadMoreButton){
              loadMoreButton.click();
            }
          }
        }.bind(this),
        offset: 'bottom-in-view'
      })
    }
  },

  /**
   * Render the section
   * 
   * @param {String} searchParams The query string to load (filters / page)
   * @param {Event} event The original trigger event
   * @param {Boolean} updateURLHash Whether to update the URL hash with the new URL
   */
  renderPage: function(searchParams, event, updateURLHash = true) {
    document.getElementById('results-loading-collection').classList.remove('d-none');
    const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;
    this.renderSectionFromFetch(url, event);

    const params = new URLSearchParams(searchParams);
    params.delete('page');

    if (updateURLHash) {
      this.updateURLHash(params.toString());
    }
  },

  /**
   * Fetch the section and re-render
   * 
   * @param {String} url URL to fetch and render 
   */
  renderSectionFromFetch: function(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;

        this.renderNewTiles(html);
        this.renderPagination(html);
        document.getElementById('results-loading-collection').classList.add('d-none');
        mp_lazyload_setup();
        Waypoint.refreshAll();

        var event = new CustomEvent("collection:updated");
        document.dispatchEvent(event);

        // Alert SWYM so it can instantiate wishlist buttons
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      });
  },

  /**
   * Extract and append the new product tiles' HTML
   * 
   * @param {String} html The HTML returned from fetch 
   */
  renderNewTiles: function(html) {
    // Extract the new product tiles from the returned HTML
    const newTiles = new DOMParser().parseFromString(html, 'text/html').querySelectorAll("[data-page]");

    // Append the new page of tiles
    Array.from(newTiles).forEach(function(element) {
      const fragment = document.createDocumentFragment();
      fragment.appendChild(element);
      this.grid.appendChild(fragment);
    }.bind(this));
  },

  /**
   * Extract and replace the pagination HTML
   * 
   * @param {String} html The HTML returned from fetch
   */
  renderPagination: function(html) {
    document.getElementById('pagination').outerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('pagination').outerHTML;
  },

  /**
   * Start the process of loading in new product tiles
   * 
   * @param {Event} event The initiating event
   */
  onLoadMoreClick: function(event) {
    event.preventDefault();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    this.renderPage(url);
  },

  /**
   * Update the URL hash with new parameters
   * 
   * @param {String} searchParams 
   */
  updateURLHash: function(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
}

export default Collection;